import { Check } from 'lucide-react';

interface SelectableDateCardProps {
  title: string;
  date: string;
  selected: boolean;
  disabled?: boolean;
  onToggle: () => void;
}

export function SelectableDateCard({
  title,
  date,
  selected,
  disabled = false,
  onToggle,
}: SelectableDateCardProps) {
  const formattedDate = new Date(date + 'T00:00:00').toLocaleDateString(
    'pt-BR',
    {
      day: '2-digit',
      month: 'short',
    },
  );

  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      className={`flex w-full items-center justify-between rounded-lg border p-4 text-left transition-colors ${
        selected
          ? 'border-primary bg-primary/5'
          : 'border-border hover:border-primary/50'
      } ${disabled ? 'opacity-50' : ''}`}
    >
      <div>
        <p className="font-medium">{title}</p>
        <p className="text-muted-foreground text-sm">{formattedDate}</p>
      </div>
      <div
        className={`flex h-6 w-6 items-center justify-center rounded-full border-2 transition-colors ${
          selected ? 'border-primary bg-primary' : 'border-muted-foreground'
        }`}
      >
        {selected && <Check className="h-4 w-4 text-white" />}
      </div>
    </button>
  );
}
